// import React from 'react';
// import { Navigate } from 'react-router-dom';

// const PrivateRoute = ({ children }) => {
//   const token = localStorage.getItem('auth_token');
//   return token ? children : <Navigate to="/" replace />;
// };

// export default PrivateRoute;


import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children, userType }) => {
  // userType = 'student' | 'admin'
  const tokenKey = userType === 'admin' ? 'admin_token' : 'student_token';
  const token = localStorage.getItem(tokenKey);

  // redirect to the correct login page if no token
  const redirectPath = userType === 'admin' ? '/admin-login' : '/';

  return token ? children : <Navigate to={redirectPath} replace />;
};

export default PrivateRoute;

